exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-found-row[data-v-1aa55a58] {\n  margin-top: 10vh;\n  text-align: center;\n}\n", ""]);

// exports
